var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"fa fa-lock pulse",staticStyle:{"font-family":"FontAwesome"}})
}
var staticRenderFns = []

export { render, staticRenderFns }